import React from 'react';
import GetName from './GetName';

//import da API


export default class ConsultaHoje extends React.Component {
  constructor() {
    super();

    this.state = {
      componentData: '',
      condition: '2',

    };
  }

  state = {
    nome: []
  }

  // componentDidMount() {
  //   // api.get(`/user?_id=${this.props.user_id}`, {headers: {'x-access-token': token}})
  //   apiProfessional.getUser(this.props.user_id)
  //     .then(res => {
  //       const nome = res.data;
  //       this.setState({ nome });
  //     })
  // }

  componentDidMount() {
    // apiProfessional.getUser(this.props.user_id)
    //   .then(res => {
    //     const nome = res.data;
    //     this.setState({ nome });
    // });
    var today = new Date();
    var birthDate = new Date(this.props.data);
    console.log(birthDate);
    var age = today.getFullYear() - birthDate.getFullYear();
    console.log(age);
    var m = today.getMonth() - birthDate.getMonth();
    console.log(m);
    var d = today.getDate() - birthDate.getDate();
    console.log(d);

    if ((age < 0)) {
      console.log(age);
      this.setState({
      componentData: age,
      })
      this.setState({ condition: 0 });
    }

    if ((age > 0)) {
      console.log(age);
      this.setState({
      componentData: age,
      })
      this.setState({ condition: 2 });
    }

    if ((m < 0 ) && (age == 0) ) {
      age--;
      console.log(age);
      this.setState({
      componentData: age,
      })
      this.setState({ condition: 0 });
    }

    if ((m > 0 ) && (age == 0) ) {
      age--;
      console.log(age);
      this.setState({
      componentData: age,
      })
      this.setState({ condition: 2 });
    }

    if ((m == 0) && (d == 0) && (age == 0) ) {
      age--;
      console.log(age);
      this.setState({
      componentData: age,

      })
      this.setState({ condition: 1 });
    }

    if ((m == 0) && (d > 0) && (age == 0) ) {
      age--;
      console.log(age);
      this.setState({
      componentData: age,
      })
      this.setState({ condition: 2 });
    }

    if ((m == 0) && (d < 0) && (age == 0) ) {
      age--;
      console.log(age);
      this.setState({
      componentData: age,
      })
      this.setState({ condition: 0 });
    }
    
    }
    render() {
      let {condition} = this.state;
      console.log( condition )
      const renderAuthButton = ()=>{
        if(condition == '1'){
          return <button id="option-PS-Painel-Alerta"><GetName user_id={this.props.user_id}/></button>
        } 
        if(condition == '2'){
          return <button id="option-PS-Painel-Passed"><GetName user_id={this.props.user_id}/></button>
        }
        if(condition == '0'){
          return <button id="option-PS-Painel"><GetName user_id={this.props.user_id}/></button>
        } 
      }
    
    return (
      <>
        {renderAuthButton()}
      </>
    )
  }
}